









































































































































import {Component, Vue} from 'vue-property-decorator';
import {入庫履歴照会型, 入庫履歴照会依頼型, 検索条件バリデータ一覧} from '@/type/stock/receive/hisotry';

import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import {progress} from '@/script/progress';

import StockItemClassSelector from '@/components/stock/item/StockItemClassSelector.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import WholesaleSelector from '@/views/stock/receive/StockReceiveWholesaleSelector.vue';
import StockDepartmentSelector from '@/views/stock/StockDepartmentSelector.vue';
import StockUserSelector from '@/views/stock/StockUserSelector.vue';
import moment from 'moment';
import {ValidationResult} from '@/type/validation/result';
import {マスタ選択区分型} from '@/type/wholesale/types';
import {loginModule} from '@/store/authentication/login';

@Component({
  components: {
    Datepicker,
    StockItemClassSelector,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    WholesaleSelector,
    StockDepartmentSelector,
    StockUserSelector,
  },
})
export default class ListStockReceiveHistories extends Vue {
  アラートメッセージ: string | string[] | null = null;
  採用品区分: マスタ選択区分型 = マスタ選択区分型.採用品;

  入庫履歴一覧: 入庫履歴照会型[] = [];
  入庫履歴照会依頼: 入庫履歴照会依頼型 = this.入庫履歴照会依頼初期値();

  検索条件バリデーション結果: ValidationResult = new ValidationResult(検索条件バリデータ一覧);

  選択行番号: number | null = null;

  created(): void {
    moment.locale('ja');
    this.initialize();
  }

  initialize() {
    this.入庫履歴照会依頼 = this.入庫履歴照会依頼初期値();
    this.入庫履歴一覧 = [];
    this.アラートメッセージ = null;
    this.選択行番号 = null;
  }

  入庫履歴照会依頼初期値(): 入庫履歴照会依頼型 {
    return {
      メーカー名: null,
      商品名カナ: null,
      入庫日From: moment().startOf('month').toDate(),
      入庫日To: null,
      商品区分: null,
      卸コード: null,
      部署コード: loginModule.部署コードを取得する,
      登録者コード: loginModule.管理者である ? '' : loginModule.利用者コードを取得する,
    };
  }

  beforeUpdate() {
    this.検索条件バリデーション結果.validate(this.入庫履歴照会依頼);
  }

  get 渓仁会仕様である(): boolean {
    return loginModule.渓仁会仕様である;
  }

  get 選択入庫伝票番号(): string | null {
    if (this.選択行番号 === null) {
      return null;
    }

    const 選択した明細 = this.入庫履歴一覧[this.選択行番号];
    const 選択した明細の伝票番号 = 選択した明細.伝票番号;

    return 選択した明細の伝票番号;
  }

  get 選択入庫履歴金額(): number | null {
    if (this.選択行番号 === null) {
      return null;
    }

    const 選択した明細 = this.入庫履歴一覧[this.選択行番号];
    const 選択した明細の卸コード = 選択した明細.卸コード;
    const 選択した明細の伝票番号 = 選択した明細.伝票番号;

    const 選択した明細と同一伝票番号を持つ明細の合計金額 = this.入庫履歴一覧
        .filter((入庫履歴) => 入庫履歴.卸コード === 選択した明細の卸コード && 入庫履歴.伝票番号 === 選択した明細の伝票番号)
        .map((入庫履歴) => 入庫履歴.合計金額)
        .reduce((accumulator, currentValue) => accumulator + currentValue);

    return 選択した明細と同一伝票番号を持つ明細の合計金額;
  }

  ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  async 検索する(): Promise<void> {
    this.選択行番号 = null;
    this.入庫履歴一覧 = [];
    await api.入庫履歴を検索する(this.入庫履歴照会依頼)
      .then((response: any) => {
        this.入庫履歴一覧 = response.入庫履歴一覧;
        if (this.入庫履歴一覧.length === 0) {
          this.アラートメッセージ = '検索結果が0件です。';
          this.$modal.show('アラート');
          return;
        }
        if (response.アラートメッセージ) {
          this.アラートメッセージ = response.アラートメッセージ;
          this.$modal.show('アラート');
        }
      })
      .catch((error: any) => {
        this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
        this.$modal.show('アラート');
      });
  }

  async 検索するハンドラ(): Promise<void> {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.検索条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    await progress(this.検索する);
  }

  async Excelファイル出力前入力チェックをする(): Promise<void> {
    if (this.検索条件バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.検索条件バリデーション結果.getMessages();
      this.$modal.show('アラート');
      return;
    }
    this.ダイアログを開く('出力ダイアログ');
  }

  async 出力する(): Promise<void> {
    await download.入庫履歴照会一覧表を出力する('入庫履歴照会一覧.xlsx', this.入庫履歴照会依頼)
            .catch((error: any) => {
              this.アラートメッセージ = this.APIアラートメッセージを取得(error.data);
              this.$modal.show('アラート');
            });
    this.ダイアログを閉じる('出力ダイアログ');
  }

  async 出力するハンドラ(): Promise<void> {
    await progress(this.出力する);
  }

  クリアする(): void {
    this.initialize();
    this.ダイアログを閉じる('クリアダイアログ');
  }

  APIアラートメッセージを取得(data: any): string[] {
    let メッセージ = [data.message];
    if (!data.errors) {
      return メッセージ;
    }
    for (const エラー of data.errors) {
      メッセージ = メッセージ.concat(['・' + エラー]);
    }
    return メッセージ;
  }

  検索条件入力エラー判定(項目名: string): boolean {
    return this.検索条件バリデーション結果.hasError(項目名);
  }

  行が選択されている(行番号: number): boolean {
    if (this.選択行番号 === null) return false;
    return this.選択行番号 === 行番号;
  }

  行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }
}
